import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../api/client';

const KycReview = () => {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState('pending');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setRows((await api.get('/api/kyc/', { params: { status } })).data);
    } catch (e) {
      toast.error('Failed to load KYC profiles');
    } finally {
      setLoading(false);
    }
  }, [status]);

  useEffect(() => { load(); }, [load]);

  const decide = async (row, decision) => {
    let reason = '';
    if (decision === 'reject') {
      reason = window.prompt('Reason for rejection (shown to the investor):') || '';
      if (reason.trim().length < 3) return;
    }
    try {
      await api.patch(`/api/kyc/${row.id}/review/`, { decision, reason });
      toast.success(decision === 'approve' ? 'Approved' : 'Rejected');
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed');
    }
  };

  const nameMatch = (a, b) => !a || !b || a.toLowerCase() === b.toLowerCase();

  return (
    <main style={{ maxWidth: 1100, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>KYC review</h1>
      <label>Status{' '}
        <select value={status} onChange={(e) => setStatus(e.target.value)} aria-label="Filter by status">
          {['pending', 'approved', 'rejected', 'not_submitted'].map((s) => <option key={s} value={s}>{s.replace('_', ' ')}</option>)}
        </select>
      </label>
      {loading ? <p>Loading…</p> : rows.length === 0 ? <p>Nothing here.</p> : rows.map((r) => (
        <article key={r.id} style={{ border: '1px solid #ddd', borderRadius: 8, padding: 12, margin: '12px 0' }}>
          <h2 style={{ margin: 0 }}>{r.full_name} <small>({r.username})</small></h2>
          <ul>
            <li>PAN: {r.pan} {r.pan_verified ? '✓' : '✗'} — name on PAN: {r.pan_name || '-'}{!nameMatch(r.full_name, r.pan_name) && ' ⚠ differs from profile name'}</li>
            <li>Aadhaar: XXXX XXXX {r.aadhaar_ref || '----'} {r.aadhaar_verified ? '✓' : '✗'}</li>
            <li>Bank: {r.bank_name} •••• {r.bank_account_last4} ({r.bank_ifsc}) — {r.penny_drop_status}; holder: {r.bank_holder_name || '-'}{!nameMatch(r.full_name, r.bank_holder_name) && ' ⚠ differs from profile name'}</li>
            <li>Residency declared: {r.residency || '-'}{r.residency && r.residency !== 'resident' && ' (cannot invest in v1)'}</li>
            {r.reject_reason && <li>Last rejection: {r.reject_reason}</li>}
          </ul>
          {r.status === 'pending' && (
            <>
              <button onClick={() => decide(r, 'approve')}>Approve</button>{' '}
              <button onClick={() => decide(r, 'reject')}>Reject…</button>
            </>
          )}
        </article>
      ))}
    </main>
  );
};

export default KycReview;
